import { Alert } from '@trussworks/react-uswds';
import { useUserRoleCapabilities } from '@stores';
interface CertifySignSubmitRoleAlertProps {
  showAlert?: boolean;
}

const CertifySignSubmitRoleAlert = ({ showAlert = true }: CertifySignSubmitRoleAlertProps) => {
  const canSignSubmitRequest = useUserRoleCapabilities((state) => state.roleCapabilities.signSubmitRequest);

  if (!showAlert || canSignSubmitRequest) return null;

  return (
    <Alert slim headingLevel='h2' className='margin-top-3 margin-bottom-3' type='warning'>
      Your role does not have authorization to certify, sign, or submit this request.     
    </Alert>
  );
};

export default CertifySignSubmitRoleAlert;
